import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { formatErrorCode } from '../../adapters/utils/utils.adapter';
import { BOOK_WIDGET_ERROR_CODES } from '../../constants/error-codes.constants';
import { CatalogApiResponse } from '../../models/core-apis/catalog-api.interfaces';
import { CatalogApiService } from '../../services/catalog-api.service';
import * as fromCatalogApiActions from '../actions/catalog-api.actions';
import * as fromErrorHandlerActions from '../actions/error-handler.actions';
import { shouldTriggerCatalogApi } from '../selectors/catalog-api.selectors';
import { getCacheKeySuffix } from '../selectors/default-lookup.selectors';

@Injectable({ providedIn: 'root' })
export class CatalogApiEffects {
  loadCatalogApi$ = createEffect(
    (): Observable<Action> =>
      this.CatalogApiActions$.pipe(
        ofType(fromCatalogApiActions.LoadCatalogApi),
        concatLatestFrom(() => [
          this.store.select(shouldTriggerCatalogApi),
          this.store.select(getCacheKeySuffix)
        ]),
        filter(
          ([, shouldTriggerCatalogApiValue]) => shouldTriggerCatalogApiValue
        ),
        switchMap(([, , cacheKey]) =>
          this.service.getCatalogApi(cacheKey).pipe(
            map((catalogApiResponse: CatalogApiResponse) =>
              fromCatalogApiActions.LoadCatalogApiSuccess({
                catalogApiData: catalogApiResponse
              })
            ),
            catchError((error: HttpErrorResponse) => {
              return of(
                fromErrorHandlerActions.HandleError({
                  errorCode: formatErrorCode(
                    BOOK_WIDGET_ERROR_CODES.CATALOG_FAILURE,
                    error?.status
                  ),
                  error: BOOK_WIDGET_ERROR_CODES.CATALOG_FAILURE
                }),
                fromCatalogApiActions.LoadCatalogApiFailure()
              );
            })
          )
        )
      )
  );

  constructor(
    private CatalogApiActions$: Actions,
    private service: CatalogApiService,
    private store: Store
  ) {}
}
